import camelize from "global/utils/camelize";
import { funAcortarText } from "global/utils/text";
import RecepiconIcon from "_+_Portal/assets/images/generico/RecepcionIcon";
import {
  BodyCardAtencionSinTurno,
  ContainerCardAtencionSinTurno,
  TopCardAtencionSinTurno,
} from "./localStyle";

const CardAtencionSinTurno = ({ demora, profesional, sede, onclick }) => {
   let message = " Minutos";
   if(demora >= 90){
    demora = Math.round(demora / 60); 
    message = demora === 1 ? " Hora": " Horas"
   }
   return (
    <ContainerCardAtencionSinTurno onClick={onclick}>
      <TopCardAtencionSinTurno>
        <RecepiconIcon color={"var(--color-white)"} />{" "}
        <span>{funAcortarText(36, camelize(profesional))}</span>
      </TopCardAtencionSinTurno>
      <BodyCardAtencionSinTurno>
        <div className="text">
          <span>
            <span className="bold">Sede:</span> {funAcortarText(30, " " + sede)}
          </span>
          <span>
            <span className="bold">Demora:</span>
            {funAcortarText(20, " " + demora + message )}
          </span>
        </div>
        <button>Recepcionarme</button>
      </BodyCardAtencionSinTurno>
    </ContainerCardAtencionSinTurno>
  );
};

export default CardAtencionSinTurno;
